import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { specials } from "@/lib/content";

export default function SpecialPreview() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Special Projects"
        title="专题策划"
        description="把相似的剧放在一起看，才看得出创作者真正想说的话。每期围绕一个主题，整理片单与推荐理由。"
        actionLabel="浏览全部专题"
        actionTo="/special"
      />

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
        {specials.slice(0, 2).map((special) => (
          <Link
            key={special.id}
            to={`/special?topic=${special.id}`}
            className="group relative block h-[280px] overflow-hidden rounded-lg md:h-[340px]"
          >
            <img
              src={special.cover}
              alt={`${special.title}专题主图`}
              title={`${special.title} - 影视专题策划`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/60 to-primary-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <p className="font-label text-[11px] font-bold uppercase tracking-[0.24em] text-accent-300">
                {special.kicker}
              </p>
              <h3 className="mt-2 font-heading text-xl font-black text-background-50 md:text-2xl">
                {special.title}
              </h3>
              <p className="mt-2 max-w-md text-sm leading-6 text-background-200 line-clamp-2">{special.intro}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-background-50">
                {special.movieIds.length} 部作品 · 查看片单
                <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}